// Role constants
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';

import { Permission } from '../types';

export enum PermissionCategory {
  DIRECTORIES = 'DIRECTORIES',
  DRIVER_COACHING = 'DRIVER_COACHING',
  REPORTS = 'REPORTS',
  SUPPORT = 'SUPPORT',
  DRIVER_PERFORMANCE = 'DRIVER_PERFORMANCE',
  DASHBOARD = 'DASHBOARD',
  ADMIN = 'ADMIN',
  ALERTS = 'ALERTS',
  TRIPS = 'TRIPS',
  ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
  NOTIFICATION = 'NOTIFICATION',
  KNOWLEDGE_CENTRE = 'KNOWLEDGE_CENTRE',
  ALARM = 'ALARM',
  DOCUMENTS = 'DOCUMENTS',
  VEHICLES = 'VEHICLES',
  SERVICE_MANAGER = 'SERVICE_MANAGER',
}

export enum PermissionSubcategory {
  // SERVICE MANAGER subcategories
  SERVICE_DOWNLOADS = 'SERVICE_DOWNLOADS',
  // Groups subcategories
  TOTAL_GROUPS = 'TOTAL_GROUPS',
  OVERLOADED_GROUPS = 'OVERLOADED_GROUPS',

  // Devices subcategories
  TOTAL_DEVICES = 'TOTAL_DEVICES',
  FAULTY_DEVICES = 'FAULTY_DEVICES',
  ACTIVE_DEVICES = 'ACTIVE_DEVICES',
  MAINTENANCE_DEVICES = 'MAINTENANCE_DEVICES',

  // Directories subcategories
  GEOFENCES = 'GEOFENCES',
  ROUTES = 'ROUTES',
  ADDRESSES = 'ADDRESSES',
  // VEHICLES = 'VEHICLES',
  GROUPS = 'GROUPS',
  DEVICES = 'DEVICES',
  MY_DRIVERS = 'MY_DRIVERS',

  // Driver Coaching subcategories
  UNDER_COACHING = 'UNDER_COACHING',
  COACHING_REQUIRED = 'COACHING_REQUIRED',
  COACHING_COMPLETED = 'COACHING_COMPLETED',
  AVERAGE_ALERTS_PER_DRIVER = 'AVERAGE_ALERTS_PER_DRIVER',

  // Driver Alerts subcategories
  AVG_ALERTS_PER_DRIVER = 'AVG_ALERTS_PER_DRIVER',

  // Reports subcategories
  ALL_REPORTS = 'ALL_REPORTS',
  SCHEDULED_REPORTS = 'SCHEDULED_REPORTS',

  // Routes subcategories
  TOTAL_ROUTES = 'TOTAL_ROUTES',
  SCHEDULED_ROUTES = 'SCHEDULED_ROUTES',
  DEVIATED_ROUTES = 'DEVIATED_ROUTES',
  UNUSED_ROUTES = 'UNUSED_ROUTES',

  // Vehicle Alerts subcategories
  TOTAL_ALERTS = 'TOTAL_ALERTS',
  CRITICAL_VEHICLE_ALERTS = 'CRITICAL_ALERTS',
  AVERAGE_ALERT_PER_DEVICE = 'AVERAGE_ALERT_PER_DEVICE',
  AVERAGE_ALERT_PER_DAY = 'AVERAGE_ALERT_PER_DAY',

  // Ignition Based Trips subcategories
  TOTAL_IGNITION_TRIPS = 'TOTAL_IGNITION_TRIPS',
  AVERAGE_TRIP_DURATION = 'AVERAGE_TRIP_DURATION',
  DISTANCE_TRAVELLED = 'DISTANCE_TRAVELLED',
  TRIPS_PER_VEHICLE = 'TRIPS_PER_VEHICLE',

  // Support subcategories
  RAISE_SUPPORT_BUTTON = 'RAISE_SUPPORT_BUTTON',
  HELPDESK = 'HELPDESK',
  VIDEO_SECTION = 'VIDEO_SECTION',
  ARTICLES = 'ARTICLES',
  FAQS = 'FAQS',
  IGNITION_TRIPS = 'IGNITION_TRIPS',
  RAISE_A_TICKET = 'RAISE_A_TICKET',

  // Driver Performance subcategories
  AVERAGE_DRIVER_SCORE = 'AVERAGE_DRIVER_SCORE',
  TOTAL_DISTANCE_DRIVEN = 'TOTAL_DISTANCE_DRIVEN',
  TOTAL_ALERTS_TRIGGERED = 'TOTAL_ALERTS_TRIGGERED',
  AVERAGE_FUEL_EFFICIENCY = 'AVERAGE_FUEL_EFFICIENCY',
  DRIVER_ALERTS_TREND = 'DRIVER_ALERTS_TREND',
  DRIVERS_BY_DRIVING_SCORES = 'DRIVERS_BY_DRIVING_SCORES',
  TOP_FIVE_PERFORMING_DRIVERS = 'TOP_FIVE_PERFORMING_DRIVERS',
  BOTTOM_FIVE_PERFORMING_DRIVERS = 'BOTTOM_FIVE_PERFORMING_DRIVERS',

  // Dashboard subcategories
  TOTAL_VEHICLES = 'TOTAL_VEHICLES',
  AVERAGE_KM_RUNNING = 'AVERAGE_KM_RUNNING',
  AVERAGE_RUNNING_TIME = 'AVERAGE_RUNNING_TIME',
  AVERAGE_IDLING_TIME = 'AVERAGE_IDLING_TIME',
  FLEET_STATUS = 'FLEET_STATUS',
  CRITICAL_ALERTS = 'CRITICAL_ALERTS',
  CRITICAL_DEVICE_FAULTS = 'CRITICAL_DEVICE_FAULTS',
  CRITICAL_DRIVERS = 'CRITICAL_DRIVERS',
  TRIPS = 'TRIPS',
  IDLING_TIME = 'IDLING_TIME',
  FLEET_SAFETY_SOCRE = 'FLEET_SAFETY_SOCRE',
  WARNINGS = 'WARNINGS',
  DISTANCE_WISE_FLEET_UTILIZATION_GRAPH = 'DISTANCE_WISE_FLEET_UTILIZATION_GRAPH',
  TIME_WISE_FLEET_UTILIZATION_GRAPH = 'TIME_WISE_FLEET_UTILIZATION_GRAPH',
  DAY_WISE_KM_RUNNING_GRAPH = 'DAY_WISE_KM_RUNNING_GRAPH',
  AVERAGE_SPEED_GRAPH = 'AVERAGE_SPEED_GRAPH',

  // My Drivers subcategories
  TOTAL_DRIVERS = 'TOTAL_DRIVERS',
  ACTIVE_DRIVERS = 'ACTIVE_DRIVERS',
  AVAILABLE_DRIVERS = 'AVAILABLE_DRIVERS',
  HIGH_ALERT_DRIVERS = 'HIGH_ALERT_DRIVERS',

  // Geofences subcategories
  TOTAL_GEOFENCES = 'TOTAL_GEOFENCES',
  OVERLAPPING_GEOFENCES = 'OVERLAPPING_GEOFENCES',
  VOILATED_GEOFENCES = 'VOILATED_GEOFENCES',
  UNUSED_GEOFENCES = 'UNUSED_GEOFENCES',

  // User Created Trips subcategories
  TOTAL_ONGOING_TRIPS = 'TOTAL_ONGOING_TRIPS',
  TOTAL_DELAYED_TRIPS = 'TOTAL_DELAYED_TRIPS',
  TOTAL_DEVIATED_TRIPS = 'TOTAL_DEVIATED_TRIPS',
  TOTAL_COMPLETED_TRIPS = 'TOTAL_COMPLETED_TRIPS',

  // Vehicles subcategories
  ACTIVE_VEHICLES = 'ACTIVE_VEHICLES',
  AVAILABLE_VEHICLES = 'AVAILABLE_VEHICLES',
  MAINTENANCE_VEHICLES = 'MAINTENANCE_VEHICLES',

  // Admin subcategories
  LIVE_STREAM_CONFIG = 'LIVE_STREAM_CONFIG',
  USER_BASED_PERMISSION = 'USER_BASED_PERMISSION',
  USER_ACCESS_CONTROLS = 'USER_ACCESS_CONTROLS',
  USER_CONTROLS = 'USER_CONTROLS',
  USER_ACCOUNTS = 'USER_ACCOUNTS',
  CUSTOMIZATION = 'CUSTOMIZATION',
  BANNER_CONFIGURATION = 'BANNER_CONFIGURATION',
  USER_SETTINGS = 'USER_SETTINGS',
  MANAGE_SUBSCRIPTIONS = 'MANAGE_SUBSCRIPTIONS',
  INTERNAL_SUBSCRIPTIONS = 'INTERNAL_SUBSCRIPTIONS',

  // User access control
  USER_ACCESS_DROPDOWN_SAVE = 'USER_ACCESS_DROPDOWN_SAVE',

  // Customisation
  MANAGE_ALERTS = 'MANAGE_ALERTS',

  // Banner configurations
  CREATE_BANNER = 'CREATE_BANNER',
  SHOW_BANNER = 'SHOW_BANNER',

  // Live stream config
  LIVE_STREAMING_CONFIGURATION = 'LIVE_STREAMING_CONFIGURATION',

  // User controls
  ADD_ACCOUNT_BUTTON = 'ADD_ACCOUNT_BUTTON',
  DOWNLOAD_BUTTON = 'DOWNLOAD_BUTTON',

  // Alerts subcategories
  VEHICLE_ALERTS = 'VEHICLE_ALERTS',
  DRIVER_ALERTS = 'DRIVER_ALERTS',
  BROADCAST = 'BROADCAST',

  // Broadcast subcategories
  CREATE_NEW = 'CREATE_NEW',

  // Scheduled Reports subcategories
  SHEDULE_NEW = 'SCHEDULE_REPORT',

  // All Reports subcategories
  MANAGER_REPORTS = 'MANAGER_REPORTS',
  ALARM_REPORTS = 'ALARM_REPORTS',
  DRIVER_PERFORMANCE_REPORTS = 'DRIVER_PERFORMANCE_REPORTS',
  DEVICE_IGNITION_REPORT = 'DEVICE_IGNITION_REPORT',
  DEVICE_HEALTH_REPORT = 'DEVICE_HEALTH_REPORT',
  DAILY_KM_REPORT = 'DAILY_KM_REPORT',
  DAILY_RUN_REPORT = 'DAILY_RUN_REPORT',
  DAILY_RUNNING_REPORT = 'DAILY_RUNNING_REPORT',
  NIGHT_DRIVE_REPORT = 'NIGHT_DRIVE_REPORT',
  CONTINUOUS_DRIVING_REPORT = 'CONTINUOUS_DRIVING_REPORT',
  ABNORMAL_STOPPAGE_REPORT = 'ABNORMAL_STOPPAGE_REPORT',
  GEOFENCING_REPORT = 'GEOFENCING_REPORT',
  PASSENGER_REPORT = 'PASSENGER_REPORT',

  // Addresses subcategories
  TOTAL_ADDRESSES = 'TOTAL_ADDRESSES',
  GEOFENCED_ADDRESSES = 'GEOFENCED_ADDRESSES',
  ACTIVE_TRIP_ADDRESSES = 'ACTIVE_TRIP_ADDRESSES',
  UNUSED_ADDRESSES = 'UNUSED_ADDRESSES',

  // Legacy subcategories for backward compatibility
  IGNITION_BASED_TRIPS = 'IGNITION_BASED_TRIPS',
  USER_CREATED_TRIPS = 'USER_CREATED_TRIPS',
  TROUBLESHOOT = 'TROUBLESHOOT',

  // Documents subcategories
  ADD_DOCUMENT = 'ADD_DOCUMENT',
  SHOW_DOCUMENT_FILTER = 'SHOW_DOCUMENT_FILTER',
}

export const SUPER_ADMIN_ONLY_CATEGORIES = [
  PermissionSubcategory.USER_ACCOUNTS,
  PermissionSubcategory.LIVE_STREAM_CONFIG,
  PermissionSubcategory.BANNER_CONFIGURATION,
];

export const ADMIN_ONLY_SUBCATEGORIES = [PermissionSubcategory.USER_ACCESS_CONTROLS];

export const NAV_ITEM_PERMISSION_MAP: Record<string, PermissionCategory> = {
  Dashboard: PermissionCategory.DASHBOARD,
  'Service Manager': PermissionCategory.SERVICE_MANAGER,
  'Account Settings': PermissionCategory.ACCOUNT_SETTINGS,
  Notification: PermissionCategory.NOTIFICATION,
  'Knowledge Centre': PermissionCategory.KNOWLEDGE_CENTRE,
  Trips: PermissionCategory.TRIPS,
  Reports: PermissionCategory.REPORTS,
  Alerts: PermissionCategory.ALERTS,
  Support: PermissionCategory.SUPPORT,
  Directories: PermissionCategory.DIRECTORIES,
  Admin: PermissionCategory.ADMIN,
  'Driver Performance': PermissionCategory.DRIVER_PERFORMANCE,
  'Driver Coaching': PermissionCategory.DRIVER_COACHING,
  Documents: PermissionCategory.DOCUMENTS,
  Vehicles: PermissionCategory.VEHICLES,
};

export const NAV_SUBCATEGORY_PERMISSION_MAP: Record<string, PermissionSubcategory> = {
  'Driver Coaching': PermissionSubcategory.UNDER_COACHING,
  'All Reports': PermissionSubcategory.ALL_REPORTS,
  'Scheduled Reports': PermissionSubcategory.SCHEDULED_REPORTS,
  'User Created Trips': PermissionSubcategory.USER_CREATED_TRIPS,
  'Ignition Based Trips': PermissionSubcategory.IGNITION_BASED_TRIPS,
  Customization: PermissionSubcategory.CUSTOMIZATION,
  'User Accounts': PermissionSubcategory.USER_ACCOUNTS,
  'Live Stream Config': PermissionSubcategory.LIVE_STREAM_CONFIG,
  'User Access Controls': PermissionSubcategory.USER_ACCESS_CONTROLS,
  'Vehicle Alerts': PermissionSubcategory.VEHICLE_ALERTS,
  'Driver Alerts': PermissionSubcategory.DRIVER_ALERTS,
  Broadcast: PermissionSubcategory.BROADCAST,
  Geofences: PermissionSubcategory.GEOFENCES,
  Routes: PermissionSubcategory.ROUTES,
  Addresses: PermissionSubcategory.ADDRESSES,
  // Vehicles: PermissionSubcategory.VEHICLES,
  Groups: PermissionSubcategory.GROUPS,
  Devices: PermissionSubcategory.DEVICES,
  'My Drivers': PermissionSubcategory.MY_DRIVERS,
  HelpDesk: PermissionSubcategory.HELPDESK,
  TroubleShoot: PermissionSubcategory.TROUBLESHOOT,
  'Video Section': PermissionSubcategory.VIDEO_SECTION,
  Articles: PermissionSubcategory.ARTICLES,
  FAQs: PermissionSubcategory.FAQS,
  'User Settings': PermissionSubcategory.USER_SETTINGS,
  'Manage Subscriptions': PermissionSubcategory.MANAGE_SUBSCRIPTIONS,
  'Internal Subscriptions': PermissionSubcategory.INTERNAL_SUBSCRIPTIONS,
  'Banner Configuration': PermissionSubcategory.BANNER_CONFIGURATION,
};

export const getPermissionCategoryFromNavItem = (navItemText: string): PermissionCategory | null => {
  return NAV_ITEM_PERMISSION_MAP[navItemText] || null;
};

export const getPermissionSubcategoryFromNavSubcategory = (
  navSubcategoryText: string,
): PermissionSubcategory | null => {
  return NAV_SUBCATEGORY_PERMISSION_MAP[navSubcategoryText] || null;
};

export const isAdminRole = (user: any): boolean => {
  return user?.authorities === ROLE_ADMIN;
};

export const isSuperAdminRole = (user: any): boolean => {
  return user?.authorities === ROLE_SUPER_ADMIN;
};

export const isAdminOrSuperAdmin = (user: any): boolean => {
  return isAdminRole(user) || isSuperAdminRole(user);
};

// Category-specific subcategory mappings for when permissions are empty arrays/objects
const CATEGORY_SUBCATEGORY_MAPPINGS: Record<string, string[]> = {
  [PermissionCategory.DASHBOARD]: [
    PermissionSubcategory.TOTAL_VEHICLES,
    PermissionSubcategory.AVERAGE_KM_RUNNING,
    PermissionSubcategory.AVERAGE_RUNNING_TIME,
    PermissionSubcategory.AVERAGE_IDLING_TIME,
    PermissionSubcategory.FLEET_STATUS,
    PermissionSubcategory.CRITICAL_ALERTS,
    PermissionSubcategory.CRITICAL_DEVICE_FAULTS,
    PermissionSubcategory.CRITICAL_DRIVERS,
    PermissionSubcategory.TRIPS,
    PermissionSubcategory.IDLING_TIME,
    PermissionSubcategory.FLEET_SAFETY_SOCRE,
    PermissionSubcategory.WARNINGS,
    PermissionSubcategory.DISTANCE_WISE_FLEET_UTILIZATION_GRAPH,
    PermissionSubcategory.TIME_WISE_FLEET_UTILIZATION_GRAPH,
    PermissionSubcategory.DAY_WISE_KM_RUNNING_GRAPH,
    PermissionSubcategory.AVERAGE_SPEED_GRAPH,
  ],
  [PermissionCategory.REPORTS]: [PermissionSubcategory.ALL_REPORTS, PermissionSubcategory.SCHEDULED_REPORTS],
  [PermissionCategory.TRIPS]: [
    PermissionSubcategory.USER_CREATED_TRIPS,
    PermissionSubcategory.IGNITION_BASED_TRIPS,
  ],
  [PermissionCategory.ADMIN]: [
    PermissionSubcategory.CUSTOMIZATION,
    PermissionSubcategory.USER_ACCESS_CONTROLS,
    PermissionSubcategory.USER_ACCOUNTS,
    PermissionSubcategory.USER_SETTINGS,
    PermissionSubcategory.LIVE_STREAM_CONFIG,
    PermissionSubcategory.MANAGE_SUBSCRIPTIONS,
    PermissionSubcategory.INTERNAL_SUBSCRIPTIONS,
  ],
  [PermissionCategory.ALERTS]: [PermissionSubcategory.DRIVER_ALERTS, PermissionSubcategory.VEHICLE_ALERTS],
  [PermissionCategory.DIRECTORIES]: [
    // PermissionSubcategory.VEHICLES,
    PermissionSubcategory.GROUPS,
    PermissionSubcategory.ROUTES,
    PermissionSubcategory.DEVICES,
    PermissionSubcategory.ADDRESSES,
    PermissionSubcategory.MY_DRIVERS,
    PermissionSubcategory.GEOFENCES,
  ],
  [PermissionCategory.DRIVER_PERFORMANCE]: [
    PermissionSubcategory.AVERAGE_DRIVER_SCORE,
    PermissionSubcategory.TOTAL_DISTANCE_DRIVEN,
    PermissionSubcategory.TOTAL_ALERTS_TRIGGERED,
    PermissionSubcategory.AVERAGE_FUEL_EFFICIENCY,
    PermissionSubcategory.DRIVER_ALERTS_TREND,
    PermissionSubcategory.DRIVERS_BY_DRIVING_SCORES,
    PermissionSubcategory.TOP_FIVE_PERFORMING_DRIVERS,
    PermissionSubcategory.BOTTOM_FIVE_PERFORMING_DRIVERS,
  ],
  [PermissionCategory.DRIVER_COACHING]: [
    PermissionSubcategory.UNDER_COACHING,
    PermissionSubcategory.COACHING_REQUIRED,
    PermissionSubcategory.COACHING_COMPLETED,
    PermissionSubcategory.AVERAGE_ALERTS_PER_DRIVER,
  ],
  [PermissionSubcategory.HELPDESK]: [PermissionSubcategory.RAISE_A_TICKET],
  [PermissionCategory.SUPPORT]: [PermissionSubcategory.RAISE_SUPPORT_BUTTON],
  [PermissionCategory.DOCUMENTS]: [
    PermissionSubcategory.ADD_DOCUMENT,
    PermissionSubcategory.SHOW_DOCUMENT_FILTER,
  ],
  [PermissionSubcategory.USER_ACCESS_CONTROLS]: [PermissionSubcategory.USER_ACCESS_DROPDOWN_SAVE],
  [PermissionSubcategory.CUSTOMIZATION]: [PermissionSubcategory.MANAGE_ALERTS],
};

export const hasCategoryAccess = (permission: Permission, category: string, user?: any): boolean => {
  if (!permission) return false;

  // If permission object is empty, allow access to all categories
  if (Object.keys(permission).length === 0) {
    return true;
  }

  // Super admin has access to everything
  if (isSuperAdminRole(user)) {
    return true;
  }

  // Admin has access to most categories except super admin specific ones
  if (isAdminRole(user)) {
    if (SUPER_ADMIN_ONLY_CATEGORIES.includes(category as PermissionSubcategory)) {
      return false;
    }
    return true;
  }

  const categoryPermission = permission[category];

  if (categoryPermission === null) {
    return false;
  }

  if (categoryPermission !== undefined) {
    return true;
  }

  return false;
};

export const hasSubcategoryAccess = (
  permission: Permission,
  category: string,
  subcategory: string,
  user?: any,
): boolean => {
  if (!permission) return false;

  if (isSuperAdminRole(user)) {
    return true;
  }

  if (
    category === PermissionCategory.ADMIN &&
    SUPER_ADMIN_ONLY_CATEGORIES.includes(subcategory as PermissionSubcategory)
  ) {
    if (!isSuperAdminRole(user)) {
      return false;
    }
  }

  if (
    category === PermissionCategory.ADMIN &&
    ADMIN_ONLY_SUBCATEGORIES.includes(subcategory as PermissionSubcategory)
  ) {
    if (!isAdminOrSuperAdmin(user)) {
      return false;
    }
  }

  if (isAdminRole(user)) {
    if (SUPER_ADMIN_ONLY_CATEGORIES.includes(subcategory as PermissionSubcategory)) {
      const adminPermissions = permission?.ADMIN;
      if (
        adminPermissions &&
        typeof adminPermissions === 'object' &&
        adminPermissions !== null &&
        !Array.isArray(adminPermissions)
      ) {
        const subcategoryPermission = (adminPermissions as Record<string, any>)[subcategory];
        return subcategoryPermission !== undefined && subcategoryPermission !== null;
      }
      return false;
    }
    return true;
  }

  if (Object.keys(permission).length === 0) {
    return true;
  }

  for (const parentKey in permission) {
    const parentPermission = permission[parentKey];
    if (parentPermission && typeof parentPermission === 'object' && !Array.isArray(parentPermission)) {
      const subcategoryPermission = (parentPermission as Record<string, any>)[category];
      if (subcategoryPermission !== undefined) {
        if (Array.isArray(subcategoryPermission)) {
          const result = subcategoryPermission.includes(subcategory);
          return result;
        } else if (subcategoryPermission === null) {
          return false;
        } else {
          return true;
        }
      }
    }
  }

  const categoryPermission = permission[category];
  if (!categoryPermission) return false;

  if (categoryPermission === null) {
    return false;
  }

  if (Array.isArray(categoryPermission)) {
    if (categoryPermission.length === 0) {
      const availableSubcategories = CATEGORY_SUBCATEGORY_MAPPINGS[category] || [];
      return availableSubcategories.includes(subcategory);
    }
    const result = categoryPermission.includes(subcategory);
    return result;
  }

  if (typeof categoryPermission === 'object') {
    if (Object.keys(categoryPermission).length === 0) {
      const availableSubcategories = CATEGORY_SUBCATEGORY_MAPPINGS[category] || [];
      return availableSubcategories.includes(subcategory);
    }

    const subcategoryPermission = categoryPermission[subcategory];

    if (subcategoryPermission === undefined) {
      return false;
    }

    if (subcategoryPermission === null) {
      return false;
    }

    if (Array.isArray(subcategoryPermission)) {
      return true;
    }

    if (subcategoryPermission !== undefined) {
      return true;
    }
  }

  return false;
};
